var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "140",
      "height": "147"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M79.408 141.262a.43.43 0 0 1-.399-.067l-.315-.233c-.176-.05-7.678-6.27-7.678-6.27-.178-.132-.23-.361-.116-.52.111-.16.361-.185.534-.073l5.503 4.079c-2.916-5.646-10.16-20.68-15.725-40.602-6.554-23.455-12.062-58.688-1.087-93.343.102-.32.47-.472.822-.339a1 1 0 0 1 .137.068c.266.166.404.478.317.754-10.886 34.372-5.42 69.347 1.082 92.633 5.633 20.175 12.987 35.288 15.771 40.647l.737-6.593c.037-.192.23-.306.44-.26a.5.5 0 0 1 .145.06.42.42 0 0 1 .205.373l-.152 9.398a.33.33 0 0 1-.221.288"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.408 141.262a.43.43 0 0 1-.399-.067l-.315-.233c-.176-.05-7.678-6.27-7.678-6.27-.178-.132-.23-.361-.116-.52.111-.16.361-.185.534-.073l5.503 4.079c-2.916-5.646-10.16-20.68-15.725-40.602-6.554-23.455-12.062-58.688-1.087-93.343.102-.32.47-.472.822-.339a1 1 0 0 1 .137.068c.266.166.404.478.317.754-10.886 34.372-5.42 69.347 1.082 92.633 5.633 20.175 12.987 35.288 15.771 40.647l.737-6.593c.037-.192.23-.306.44-.26a.5.5 0 0 1 .145.06.42.42 0 0 1 .205.373l-.152 9.398a.33.33 0 0 1-.221.288"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }